
import React from 'react';

export const PhoneIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    phone
  </span>
);